document.addEventListener('compilationToggle', (e) => {
  if (e.detail.linkElement && !e.detail.inCompilation) {
    const link = e.detail.linkElement;
    const card = link.closest('[data-compilation-card]');
    if (card) {
      card.remove();
    }
  }
});